import React from 'react';
import { Tooltip } from 'antd';
import cn from 'classnames';
import styles from './SelectStreets.module.scss';

export const renderOption = (street, over = 23) => {
  const name = street.name;

  let option = name;

  if (street.city) {
    option = (
      <div>
        <p className={cn(styles.text, styles.city)}>{street.city}</p>
        <p className={cn(styles.text, styles.name)}>{name}</p>
      </div>
    );
  }

  if (name.length > over || street.city?.length > over) {
    option = (
      <Tooltip title={option} mouseEnterDelay={1}>
        {option}
      </Tooltip>
    );
  }

  return option;
};
